import { apiRoutes } from 'config/apiRoutes'
import { useMutation } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { defaultConfig } from 'config/default'
import { downloadAs } from 'utils/downloadFile'
import { useTranslation } from 'libs/i18n'

type UseExportAreasMutationProps = {
	chosenFormat: number | null
	onSuccess: () => void
	onSettled: () => void
}

export const useExportAreasMutation = ({
	chosenFormat,
	onSuccess,
	onSettled
}: UseExportAreasMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: exportAreasMutation, isPending: isExportAreasLoading } = useMutation({
		mutationFn: ({ format, ids }: { format: number | null; ids: number[] }) => {
			return axiosPrivate.post(apiRoutes.areasExport, { format, ids })
		},
		onSuccess: (res) => {
			const format = defaultConfig.exportFormatOptions
				.find((format) => format.value === chosenFormat)
				?.label.toLowerCase()

			if (format) {
				downloadAs({ file: res.data, name: 'booths-export', format })
			}

			onSuccess()
			useToast({
				type: 'success',
				message: t('Areas exported')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled
	})

	return {
		exportAreasMutation,
		isExportAreasLoading
	}
}
